<template>
  <div class="ResumoAverbacoes">
    <div class="ResumoAverbacoes-add mt-2">
      <div v-if="!addBox"
           class="text-right">
        <button id="add_averb"
                class="btn btn-sm btn-primary"
                @click="addBox = true">
          <svg class="ResumoAverbacoes-show_icon icon--xxs"
               role="presentation">
            <use :xlink:href="'#' + icons.plus.id" />
          </svg>
          Adicionar
        </button>
      </div>

      <div
        v-if="addBox"
        class="mt-3 pb-2 resumo-show_header--shadow ResumoAverbacoes-addBox">
        <div class="resumo-show_header--grey">
          Nova Averbação
        </div>
        <div class="row ResumoAverbacoes-addBox__content">
          <div class="col-12">
            <div class="col-3">
              <div class="form-group">
                <label
                  class="label"
                  for="data_averbacao">Data Averbação
                </label>
                <input
                  id="data_averbacao"
                  v-model="averbacao.data_averbacao"
                  v-mask="`99/99/9999`"
                  v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
                  :class="{ 'is-invalid': errors.has('data_averbacao') }"
                  class="form-control form-control-sm"
                  name="data_averbacao"
                  placeholder="00/00/0000"
                  type="date">
                <small
                  v-if="errors.has('data_averbacao')"
                  class="invalid-feedback">{{ errors.first('data_averbacao') }}</small>
              </div>
            </div>
          </div>

          <div class="col-4 ResumoAverbacoes-addBox__content">
            <div class="form-group ml-3">
              <span class="custom-control custom-switch mr-4">
                <input
                  id="certidao"
                  v-model="averbacao.averb_acrescida_certidao"
                  class="custom-control-input"
                  name="tipo_registro"
                  type="checkbox"
                  @keyup.enter="averbacao.averb_acrescida_certidao = !averbacao.averb_acrescida_certidao">
                <label
                  class="custom-control-label"
                  for="certidao">Averbação acrescida na certidão</label>
              </span>
            </div>
          </div>

          <div class="col-4 ResumoAverbacoes-addBox__content">
            <div class="form-group">
              <span class="custom-control custom-switch mr-4">
                <input
                  id="livro"
                  v-model="averbacao.averb_impressa_livro"
                  class="custom-control-input"
                  name="tipo_registro"
                  type="checkbox"
                  @keyup.enter="averbacao.averb_impressa_livro = !averbacao.averb_impressa_livro">
                <label
                  class="custom-control-label"
                  for="livro">Averbação impressa no livro</label>
              </span>
            </div>
          </div>

          <div v-if="!!propTransporte"
               class="col-4 ResumoAverbacoes-addBox__content">
            <div class="form-group">
              <span class="custom-control custom-switch mr-4">
                <input
                  id="transporte"
                  v-model="averbacao.averb_impressa_transporte"
                  class="custom-control-input"
                  name="tipo_registro"
                  type="checkbox"
                  @keyup.enter="averbacao.averb_impressa_transporte = !averbacao.averb_impressa_transporte">
                <label
                  class="custom-control-label"
                  for="transporte">Averbação impressa no transporte</label>
              </span>
            </div>
          </div>

          <div class="col-7"
               data-tooltip="Escolha a minuta">
            <div class="form-group">
              <div class="tooltipHelp"
                   data-tooltip="A minuta selecionada aqui será apresentada na área de texto abaixo para edição">
                <label class="label">Escolha a minuta</label>
                <icon-svg icon="helpCircle"
                          class="iconBlue" />
              </div>

              <select id="titulo_minuta"
                      ref="titulo_minuta"
                      v-model="averbacao.texto_averbacao"
                      class="form-control form-control-sm"
                      name="titulo_minuta"
                      :disabled="!minutas.length">
                <option selected
                        :value="''">
                  Selecione
                </option>
                <option v-for="(minuta, index) in minutas"
                        :key="`titulo_minuta${_uid}_${index}`"
                        :value="minuta.descricao">
                  {{ minuta.titulo }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <textarea
              id=""
              v-model="averbacao.texto_averbacao"
              class="form-control form-control-sm"
              name=""
              rows="5" />
          </div>
        </div>

        <div class="text-right m-2">
          <button class="btn btn-sm btn-danger mr-2"
                  @click="cancelAddAverb">
            Cancelar
          </button>
          <button class="btn btn-sm btn-primary"
                  @click="store">
            Adicionar
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="editAverbacao"
      class="mt-3 pb-2 resumo-show_header--shadow ResumoAverbacoes-addBox">
      <div class="resumo-show_header--grey">
        Editar Averbação
      </div>
      <div class="row ResumoAverbacoes-addBox__content">
        <div class="col-12">
          <div class="col-3">
            <div class="form-group">
              <label
                class="label"
                for="data_averbacao_edit">Data Averbação
              </label>
              <input
                id="data_averbacao_edit"
                ref="data_averbacao_edit"
                v-model="editAverbacao.data_averbacao"
                :class="{ 'is-invalid': errors.has('data_averbacao_edit') }"
                :disabled="editAverbacao.origem && editAverbacao.origem === 'SOFIA_GED'"
                class="form-control form-control-sm"
                name="data_averbacao_edit"
                placeholder="00/00/0000"
                type="date">
              <small
                v-if="errors.has('data_averbacao_edit')"
                class="invalid-feedback">{{ errors.first('data_averbacao_edit') }}</small>
            </div>
          </div>
        </div>
      

        <div class="col-4 ResumoAverbacoes-addBox__content">
          <div class="form-group ml-3">
            <span class="custom-control custom-switch mr-4">
              <input
                id="certidao-edit"
                v-model="editAverbacao.averb_acrescida_certidao"
                class="custom-control-input"
                name="tipo_registro"
                type="checkbox">
              <label
                class="custom-control-label"
                for="certidao-edit">Averbação acrescida na certidão</label>
            </span>
          </div>
        </div>

        <div class="col-4 ResumoAverbacoes-addBox__content">
          <div class="form-group">
            <span class="custom-control custom-switch mr-4">
              <input
                id="livro-edit"
                v-model="editAverbacao.averb_impressa_livro"
                class="custom-control-input"
                name="tipo_registro"
                type="checkbox">
              <label
                class="custom-control-label"
                for="livro-edit">Averbação impressa no livro</label>
            </span>
          </div>
        </div>

        <div v-if="!!propTransporte"
             class="col-4 ResumoAverbacoes-addBox__content">
          <div class="form-group">
            <span class="custom-control custom-switch mr-4">
              <input
                id="transporte-edit"
                v-model="editAverbacao.averb_impressa_transporte"
                class="custom-control-input"
                name="tipo_registro"
                type="checkbox">
              <label
                class="custom-control-label"
                for="transporte-edit">Averbação impressa no transporte</label>
            </span>
          </div>
        </div>

        <div class="col-7"
             data-tooltip="Escolha a minuta">
          <div class="form-group">
            <div class="tooltipHelp"
                 data-tooltip="A minuta selecionada aqui será apresentada na área de texto abaixo para edição">
              <label class="label">Escolha a minuta</label>
              <icon-svg icon="helpCircle"
                        class="iconBlue" />
            </div>

            <select id="titulo_minuta"
                    ref="titulo_minuta"
                    v-model="editTextoAverbacao"
                    class="form-control form-control-sm"
                    name="titulo_minuta"
                    :disabled="!minutas.length || (editAverbacao.origem && editAverbacao.origem === 'SOFIA_GED')"
                    @change="changeEditTextoAverb()">
              <option :value="''"
                      selected>
                Selecione
              </option>
              <option v-for="(minuta, index) in minutas"
                      :key="`titulo_minuta${_uid}_${index}`"
                      :value="minuta.descricao">
                {{ minuta.titulo }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12">
          <textarea
            id=""
            v-model="editAverbacao.texto_averbacao"
            :disabled="editAverbacao.origem && editAverbacao.origem === 'SOFIA_GED'"
            class="form-control form-control-sm"
            name=""
            rows="5" />
        </div>
      </div>

      <div class="text-right m-2">
        <button class="btn btn-sm btn-danger mr-2"
                @click="() => { editAverbacao = null; editTextoAverbacao = '' }">
          Cancelar
        </button>
        <button class="btn btn-sm btn-primary"
                @click="update">
          Atualizar
        </button>
      </div>
    </div>


    <NoResults v-if="!averbacoes.length && !addBox" />

    <div v-if="!editAverbacao"
         class="ResumoAverbacoes-container mt-3">
      <div v-for="(averb, index) in averbacoes"
           :key="index"
           class="ResumoAverbacoes-container-item mb-3">
        <div class="ResumoAverbacoes-container-item__title  d-flex d-inline justify-content-between">
          <div class="d-flex d-inline justify-content-between">
            <svg v-if="averb.origem && averb.origem === 'SOFIA_GED'"
                 class="icon--sm gedIcon"
                 role="presentation">
              <use :xlink:href="'#' + icons.gedIcon.id" />
            </svg>
            <p>{{ averb.data_averbacao | date }}</p>
            <p class="flag-averb"
               :class="{'flag-averb-disabled': !averb.averb_acrescida_certidao}">
              Averbação acrescida na certidão
              <IconSvg v-if="averb.averb_acrescida_certidao"
                       class="icon-done-averb"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close-averb"
                       icon="close2" />
            </p>
            <p class="flag-averb"
               :class="{'flag-averb-disabled': !averb.averb_impressa_livro}">
              Averbação impressa no livro
              <IconSvg v-if="averb.averb_impressa_livro"
                       class="icon-done-averb"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close-averb"
                       icon="close2" />
            </p>
            <p v-if="!!propTransporte"
               class="flag-averb"
               :class="{'flag-averb-disabled': !averb.averb_impressa_transporte}">
              Averbação impressa no transporte
              <IconSvg v-if="averb.averb_impressa_transporte"
                       class="icon-done-averb"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close-averb"
                       icon="close2" />
            </p>
          </div>

          <div class="text-right">
            <button class="btn btn-sm btn-primary mr-2"
                    @click="editarAverbacao(averb)">
              <svg class="ResumoAverbacoes-show_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + icons.edit.id" />
              </svg>
            </button>
            <button v-if="!averb.origem || (averb.origem && averb.origem !== 'SOFIA_GED')"
                    class="btn btn-sm btn-danger mr-2"
                    @click="destroy(averb.documento_id)">
              <svg class="ResumoAverbacoes-show_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + icons.trash.id" />
              </svg>
            </button>
            <button class="btn btn-sm btn-primary"
                    @click="imprimirAverbacao(averb)">
              <svg class="ResumoAverbacoes-show_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + icons.printer.id" />
              </svg>
            </button>
          </div>
        </div>

        <div class="ResumoAverbacoes-container-item__content">
          {{ averb.texto_averbacao }}
        </div>
      </div>
    </div>

    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>

<script>
  /* assets */
  import plus from "@/assets/icons/add.svg?sprite"
  import note from "@/assets/icons/ICONS_todos/ICONS/note.svg?sprite"
  import edit from "@/assets/icons/SINOREG/edit.svg?sprite"
  import trash from '@/assets/icons/delete.svg?sprite'
  import printer from '@/assets/icons/print.svg?sprite'
  import gedIcon from '@/assets/icons/ged-temp.svg?sprite'

  /* components */
  import GridCertificados from '@/components/GridCertificados'
  import NoResults from "@/components/SofiaRei/Resumo/NoResults"

  /* services */
  import DocumentosService from "@/services/Documentos"
  import BryService from '@/services/Assinaturas/BryService'
  import AverbacoesService from "@/services/Registros/AverbacoesService"
  import MinutasService from "@/services/MinutasService"
  import ImpressaoService from '@/services/Registros/ImpressaoService'

  /* libraries */
  import moment from "moment"

  /* constants */
  import { IMPRIMIR_AVERBACOES, ADMIN } from "@/constants/permissions"

  /* outros */
  import {mapGetters} from "vuex"

  const AVERBACAO_DFLT = {
    data_averbacao: new Date().toISOString().split('T')[0],
    texto_averbacao: '',
    averb_acrescida_certidao: false,
    averb_impressa_livro: false,
    averb_impressa_transporte: false
  }

  export default {
    name: "ResumoAverbacoes",
    components: {
      NoResults,
      GridCertificados
    },
    props: {
      registroId: { type: Number, required: true },
      tipoRegistro: { type: String, required: true },
      propTransporte: {type: Object, default: null }
    },
    data () {
      return {
        icons: { plus, note, trash, printer, edit, gedIcon },
        printSettings: { objPrinters: {}, listPrinters: [] },
        addBox: false,
        averbacao: Object.assign({}, AVERBACAO_DFLT),
        averbacoes: [],
        editAverbacao: null,
        averbacaoId: null,
        certificados: null,
        certificadoSelecionado: null,
        certificateData: null,
        crud: null,
        averbacaoBkp: {},
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        minutas: [],
        editTextoAverbacao: '',
        IMPRIMIR_AVERBACOES,
        ADMIN,
        livroDeRegistro: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    async mounted () {
      this.init ()
    },

    methods: {
      async init () {
        loader({ text: 'Aguarde...', active: true })
        /* carregando averbacoes */
        const averbacoes = await AverbacoesService.getAverbacaoByRegistroId(this.registroId)
        this.averbacoes = averbacoes

        /* zerando id averbacao */
        this.averbacaoId = null

        /* zerando form cadastro */
        this.addBox = false
        this.averbacao = Object.assign({}, AVERBACAO_DFLT)

        /* zerando form de edicao */
        this.editAverbacao = null

        // this.printSettings.listPrinters = await listarImpressoras()
        this.printSettings.listPrinters.forEach((item, index) => this.printSettings.objPrinters[index] = item.name)

        const minutas = await MinutasService.getMinuta ({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: 100,
          page: 1,
          tipo_registro: this.tipoRegistro
        })

        this.minutas = minutas.data

        const livroDeRegistro = await DocumentosService.getLivroDeRegistro(this.registroId)

        if (livroDeRegistro) {
          this.livroDeRegistro = livroDeRegistro
        }

        setTimeout(() => {
          const addImg = document.getElementById('add_averb')

          if (addImg) addImg.focus()
        }, 300)

        loader({ active: false })
      },
      store () {
        this.$validator.validate().then(resp => {
          let invalids = document.querySelectorAll('.is-invalid')

          if (resp && invalids.length === 0) {
            this.crud = 'store'

            // Só chamamos o certificado existe o livro de registro e a averbação impressa no livro estiver selecionado
            if (this.livroDeRegistro) {
              this.averbacao.averb_impressa_livro ? this.obterCertificados() : this.direcionaCRUD(false)
            } else {
              this.direcionaCRUD(false)
            }
          }
        })
      },

      cancelAddAverb () {
        this.addBox = false
        this.averbacao = { ...AVERBACAO_DFLT }
      },

      changeEditTextoAverb () {
        this.editAverbacao.texto_averbacao = this.editTextoAverbacao
      },

      update () {
        this.$validator.validate().then(async resp => {
          let invalids = document.querySelectorAll('.is-invalid')

          if (resp && invalids.length === 0) {
            this.crud = 'update'

            // Só chamamos o certificado existe o livro de registro e a averbação impressa no livro estiver selecionado
            if (this.livroDeRegistro) {
              this.editAverbacao.averb_impressa_livro ? this.obterCertificados() : this.direcionaCRUD(false)
            } else {
              this.direcionaCRUD(false)
            }
          }
        })
      },

      destroy (averbacaoId) {
        this.averbacaoId = averbacaoId
        this.crud = 'destroy'

        const averbacao = this.averbacoes.find(averbacao => averbacao.documento_id === averbacaoId)

        if (!averbacao) return

        // Só chamamos o certificado existe o livro de registro e a averbação impressa no livro estiver selecionado
        if (this.livroDeRegistro) {
          averbacao.averb_impressa_livro ? this.obterCertificados() : this.direcionaCRUD(false)
        } else {
          this.direcionaCRUD(false)
        }
      },

      async obterCertificados () {
        loader({ text: 'Validando extensão...', active: true })

        if (!BryService.isExtensionInstalled()) {
          loader({ text: '', active: false })

          objSwal.info.title = 'Extensão não instalada'
          objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
          objSwal.info.html = ''
          objSwal.info.confirmButtonText = 'Instalar'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não'

          return Swal.fire(objSwal.info).then(({ value }) => {
            if (value) {
              try {
                BryService.getExtension()
              } catch (e) {
                this.onLoginError('Erro', e.message)
              } finally {
                this.editTextoAverbacao = ''
              }
            }
          })
        }

        loader({ text: 'Obtendo certificados...', active: true })

        // Retornamos apenas certificados do tipo 'A3'
        const certificados = await BryService.getCertificates()

        this.certificados = certificados.filter(certificate => {
          return certificate.certificateType === 'A3'
        })

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          return this.onError('Erro', 'Não foi possível selecionar o certificado. Nenhum certificado foi encontrado')
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          this.direcionaCRUD()
        }
      },

      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado
        // Fechando modal
        this.$refs.modalCertificados.hide()
        // Anulando certificados obtidos
        this.certificados = null

        this.direcionaCRUD()
      },

      async direcionaCRUD (realizarAssinatura = true) {
        if (this.crud === 'store') {
          this.gravarAverbacao(true, realizarAssinatura)

        } else if (this.crud === 'update') {
          this.editAverbacao.origem && this.editAverbacao.origem === 'SOFIA_GED' ? this.atualizaAverbacaoGED(realizarAssinatura) : this.atualizaAverbacao(realizarAssinatura)
          
        } else if (this.crud === 'destroy') {
          this.excluirAverbacao(realizarAssinatura)
        }
      },

      gravarAverbacao (showAlert = true, realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de store averbacoes
        AverbacoesService.incluirAverbacao(this.registroId, this.averbacao).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            if (showAlert) {
              // Mensagem de sucesso
              objSwal.success.title = "Averbação cadastrada com sucesso!"
              objSwal.success.text = ''
              objSwal.success.html = ''
              await Swal.fire(objSwal.success)
            }

            await this.init()
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            if (showAlert) {
              const message = getErrors(error)

              return displayMessage('error', 'Erro!', message.message)
            }
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null

            NProgress.done()
            loader({ text: '', active: false })
          })
      },

      editarAverbacao (averbacao) {
        const data = averbacao.data_averbacao
        this.editAverbacao = { ...averbacao, data_averbacao: data.split('T')[0] }
        this.averbacaoBkp = { ...averbacao, data_averbacao: data.split('T')[0] }

        setTimeout(() => {
          const dataAverbacaoEdit = document.getElementById('data_averbacao_edit')

          if (dataAverbacaoEdit) dataAverbacaoEdit.focus()
        }, 300)
      },

      atualizaAverbacao (realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de update averbacoes
        AverbacoesService.atualizarAverbacao(this.editAverbacao.documento_id, this.editAverbacao).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            // Mensagem de sucesso
            objSwal.success.title = "Averbação atualizada com sucesso!"
            objSwal.success.text = ''
            objSwal.success.html = ''

            await Swal.fire(objSwal.success)

            await this.init()
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null

            NProgress.done()
            loader({ text: '', active: false })
          })
      },

      excluirAverbacao (realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de destroy averbacoes
        AverbacoesService.excluirAverbacao(this.averbacaoId).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            // Mensagem de sucesso
            objSwal.success.title = "Averbação removida com sucesso!"
            objSwal.success.text = ''
            objSwal.success.html = ''
            await Swal.fire(objSwal.success)

            // Atualiza lista de averbações
            await this.init()
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null

            NProgress.done()
            loader({ text: '', active: false })
          })
      },

      async assinaturaAverbacao (documentoLivroDeRegistro) {
        try {
          // Guarda o certificateData para quando assinarmos o Livro de Registro.
          this.certificateData = this.certificadoSelecionado.certificateData

          // Inicia a assinatura
          const iniciaAssinatura = await BryService.startSigning(this.certificateData, documentoLivroDeRegistro.documento_id)

          // Trata o objeto da assinatura
          const assinaturasObj = iniciaAssinatura.assinaturasInicializadas.map(({ nonce, messageDigest }) => {
            return BryService.prepareContentForSignature(messageDigest, nonce)
          })

          const { certId } = this.certificadoSelecionado

          // Digita a senha do certificado
          const { assinaturas } = await BryService.signBase64Content(certId, assinaturasObj)

          // Finaliza a assinatura
          await BryService.endSigning(iniciaAssinatura.nonce, assinaturas)
        } catch (e) {
          /* carregando dados */
          await this.init()

          console.error(e)
          throw "Erro ao assinar"
        } finally {
          this.editTextoAverbacao = ''
        }
      },

      async imprimirAverbacao (averbacao) {
        // Verificamos a permissão no método pois nenhuma rota é chamada
        // Se for suporte ou oficial não validamos
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [ this.IMPRIMIR_AVERBACOES, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        try {
          loader({active: true})
          const url = await ImpressaoService.etiqueta({ textoImpressao: averbacao.texto_averbacao })

          window.open(url)
        } catch (e) {
          displayMessage('error', 'Erro!', 'Não foi possível gerar o PDF da impressão')
        } finally {
          loader({active: false})
        }
      },

      onError (title, text) {
        loader({ text: '', active: false })

        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ''
        return Swal.fire(objSwal.error)
      },

      atualizaAverbacaoGED (realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de update averbacoes
        AverbacoesService.atualizarAverbacaoGED(this.editAverbacao).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            // Mensagem de sucesso
            objSwal.success.title = "Averbação atualizada com sucesso!"
            objSwal.success.text = ''
            objSwal.success.html = ''

            await Swal.fire(objSwal.success)

            await this.init()
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null

            NProgress.done()
            loader({ text: '', active: false })
          })
      },
    }
  }
</script>

<style lang="scss">
@import "../../../scss/_utilities/exports";

.ResumoAverbacoes {
	&-show {
		&_title {
			background-color: $sinoreg-blue;
			color: $color-white;
			font-size: pxToRem(22);
			font-weight: 500;
			padding: pxToRem(8);
		}

		&_title-label {
			font-size: pxToRem(22);
			font-weight: 500;
		}

		&_icon {
			fill: $color-white;
		}

		&_label {
			font-size: pxToRem(14);
		}

		&_sublabel {
			font-size: pxToRem(14);
			font-weight: 600;
		}

		&_header{
			&--grey{
				background-color: $sinoreg-card-gray;
				cursor: pointer;
				padding: pxToRem(10) pxToRem(20);
				color: $color-black;
				font-weight: 500;
				font-size: pxToRem(16);
			}

			&--blue{
				background-color: $color-light-blue;
				padding: pxToRem(10) pxToRem(20);
				color: $color-black;
				font-weight: 500;
				font-size: pxToRem(16);
			}

			&--shadow{
				box-shadow: 1px 2px pxToRem(7) $color-gray;
			}

			&--label{
				text-decoration: underline;
				font-size: pxToRem(13);
				margin-bottom: 0;
			}

			&--sublabel{
				font-size: pxToRem(13);
			}
		}

		&_vinculacao-header{
			font-size: pxToRem(12);
		}

		&_vinculacao-divider{
			border-top: 1px solid black;
		}

		&_hr{
			border-top: 1px solid $sinoreg-blue;
		}
	}
	&-addBox {
  	&__title {
			background-color: black;
			color: white;
		}
		&__content {
			padding: 10px;
      &--flag {
        padding: 25px 0 0 0;
      }
		}
	}
 	&-container {
     min-height: 250px;
		 &-item {
        &__title {}
        &__content {}
        border: solid grey 1px;
        padding: 5px;

        .btn {
          border-radius: 50%
        }
     }
 	}
	&.collapsed > .when-opened,
	:not(.collapsed) > .when-closed {
		display: none;
	}

	&.icons {

		&--black{
			fill: black;
		}
  }

  .icon-done-averb {
    width: 20px;
    height: 20px;
  }

  .icon-close-averb {
    width: 20px;
    height: 20px;
  }

  .flag-averb {
    margin: 0px 30px 0px 30px;

    &-disabled {
      color: #c6c6c6;
      fill: #C6C6C6
    }
  }

  .iconBlue {
    fill: #074f7f;
    height: 1.3rem;
    width: 1.3rem;
    margin-bottom: 3px;
    margin-left: 6px;
  }

  .tooltipHelp::before,
  .tooltipHelp::after {
    --scale: 0;
    --tooltip-color: #F9F9F9;
    --tooltip-color-border: rgba(0,0,0,.3);
    position: absolute;
    z-index: 1;
    content: '';
    bottom: -1rem;
    transition: 35ms;
    transform-origin: bottom center;
    transform: translateX(15%) translateY(44%) scale(var(--scale));
  }

  .tooltipHelp::before {
    content: attr(data-tooltip);
    padding: .5rem;
    width: 38%;
    color: black;
    border-radius: .7rem;
    word-wrap: break-word;
    background: var(--tooltip-color);
    box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
    -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
    filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
  }

  .tooltipHelp:hover::before,
  .tooltipHelp:hover::after {
    --scale: 1;
  }

  .tooltipHelp:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: solid;
    box-shadow: 0px 10px 20px 10;
    border-width: 0px 10px 20px 10px;
    transform: translateX(-100%) translateY(-240%) scale(var(--scale));
    border-color: transparent transparent var(--tooltip-color) transparent;
    -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
    filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
  }
}

.dataAverbacaoGed {
  display: contents;
}

.gedIcon {
  width: 47px;
  padding-bottom: 2px;
  margin-right: 25px;
}

</style>
